import { render, staticRenderFns } from "./SignUpCard.vue?vue&type=template&id=3ed4f758&scoped=true&"
import script from "./SignUpCard.vue?vue&type=script&lang=ts&"
export * from "./SignUpCard.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpCard.vue?vue&type=style&index=0&id=3ed4f758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4f758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VApp,VCard,VDivider})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
